"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TherapistOfficeSchema = exports.TherapistOfficeLocationSchema = exports.GoogleMapsPlaceTypeItemSchema = void 0;
const zod_1 = require("zod");
// https://github.com/colinhacks/zod/issues/2600
const LocationLongitudeSchema = zod_1.z.number().min(-180).max(180);
const LocationLatitudeSchema = zod_1.z.number().min(-90).max(90);
exports.GoogleMapsPlaceTypeItemSchema = zod_1.z.object({
    longText: zod_1.z.string().nullable(),
    shortText: zod_1.z.string().nullable(),
    types: zod_1.z.array(zod_1.z.string()),
});
exports.TherapistOfficeLocationSchema = zod_1.z.object({
    address: zod_1.z.string().min(1),
    lng: LocationLongitudeSchema,
    lat: LocationLatitudeSchema,
});
exports.TherapistOfficeSchema = zod_1.z
    .object({
    phoneNumber: zod_1.z.string(),
    wheelchairAccessible: zod_1.z.boolean(),
    freeParking: zod_1.z.boolean(),
    paidParkingNearby: zod_1.z.boolean(),
    waitingAreaAvailable: zod_1.z.boolean(),
    additionalInformation: zod_1.z.string(),
    location: exports.TherapistOfficeLocationSchema,
})
    .openapi('TherapistOffice');
